var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHistoryReporting)?_c('cycles-completed-banner-chart'):_vm._e(),(_vm.showCurrentReporting)?_c('user-activity-chart'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }